import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { fr } from "../content/fr";
import Seo from "../components/Seo";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Reveal } from "../components/ui-bits";

export default function Legal() {
  const { doc } = useParams();
  const data = fr.legal.docs[doc];
  if (!data) return <Navigate to="/legal/mentions" replace />;

  return (
    <div>
      <Seo routeKey="/legal" path={`/legal/${doc}`} title={`${data.title} | VIRALYA`} />
      <Header />
      <main className="page">
        <div className="container page-narrow">
          <Link to="/" className="back-link" data-testid="legal-back"><ArrowLeft size={15} /> Accueil</Link>
          <span className="eyebrow"><span className="sq" />Légal</span>
          <h1 className="h2" style={{ marginBottom: "0.5rem" }} data-testid="legal-title">{data.title}</h1>
          <p className="muted" style={{ marginBottom: "2rem", fontSize: "0.85rem" }}>{fr.legal.updated}</p>
          <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            {data.sections.map((s, i) => (
              <Reveal className="glass card" key={i} delay={i * 0.04}>
                <h3 className="card__title">{s.h}</h3>
                <p className="card__desc">{s.p}</p>
              </Reveal>
            ))}
          </div>
          <div style={{ display: "flex", gap: "0.6rem", flexWrap: "wrap", marginTop: "2rem" }}>
            {Object.entries(fr.legal.docs).map(([key, d]) => (
              <Link key={key} to={`/legal/${key}`} className="badge" data-testid={`legal-tab-${key}`}
                style={key === doc ? { borderColor: "var(--brand-violet)", color: "var(--brand-violet)" } : undefined}>
                {d.title}
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
